module.exports = __webpack_public_path__ + "static/UIColors-00f954c6191270f52ba46db6eee0d977.jpg";